var map = {
	"./bs_crotch_blk.png": 118703,
	"./bs_crotch_blu.png": 552145,
	"./bs_crotch_cho.png": 767014,
	"./bs_crotch_cml.png": 884614,
	"./bs_crotch_crk.png": 846492,
	"./bs_crotch_dor.png": 143001,
	"./bs_crotch_gld.png": 909333,
	"./bs_crotch_grn.png": 320397,
	"./bs_crotch_gry.png": 97282,
	"./bs_crotch_lmn.png": 695555,
	"./bs_crotch_mgn.png": 604148,
	"./bs_crotch_nvy.png": 964867,
	"./bs_crotch_orn.png": 710085,
	"./bs_crotch_pnk.png": 644103,
	"./bs_crotch_ppl.png": 168422,
	"./bs_crotch_red.png": 558811,
	"./bs_crotch_sax.png": 763814,
	"./bs_crotch_sil.png": 459610,
	"./bs_crotch_wht.png": 79745
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 676319;